export const habaCountryPopup = {
  countryPopup: {
    retainCountry: 'In diesem Shop sind nur Lieferungen nach {{country}} möglich',
    changeCountry: 'Für Bestellungen mit einer abweichenden Lieferadresse wählen Sie bitte ein anderes Land.',
    buttonRetain: 'Land beibehalten',
    buttonChange: 'Auswahl bestätigen',
    countryLabel: 'Land wählen',
    languageLabel:'Sprache',
    infoText: 'Ihr Warenkorb wird geleert, wenn Sie das Land wechseln.'
  }
};
